import * as React from 'react';
import type { FactsSectionBlockViewModel } from '../ViewModel/FactsSectionBlockViewModel.csharp';
import type { FactsSectionProps } from '~/Features/StudyPage/Campus/Sections/FactsSection/FactsSection';
import { FactsSection } from '~/Features/StudyPage/Campus/Sections/FactsSection/FactsSection';

const mapFacts = (facts: FactsSectionBlockViewModel['facts']): FactsSectionProps['facts'] =>
    facts.map(fact => ({
        title: fact.title,
        content: fact.content,
        iconName: fact.icon,
    }));

const mapTags = (tags: FactsSectionBlockViewModel['tags']): FactsSectionProps['tags'] =>
    tags.map(tag => ({
        title: tag.title,
        value: tag.value,
        iconName: tag.icon,
    }));

export const FactsSectionBlock: React.FC<FactsSectionBlockViewModel> = props => {
    const { id, title, facts, tags } = props;

    return <FactsSection id={id} title={title} facts={mapFacts(facts)} tags={mapTags(tags)} />;
};
